import { createTranslations } from '@npco/utils-translations'

export const setupFlowStartStageTranslations = createTranslations({
  title: 'Welcome to Zeller',
  description:
    'This short introduction will help you set up a suite of financial tools to help run and grow your business.',
})
